let truncate = (str, maxLength) => {
  if (str.length <= maxLength) {
    return str
  }

  return str.slice(0, maxLength - 3) + '...'
}

let truncateWithSuffix = (str, maxLength) => {
  if (str.length <= maxLength) {
    return str
  }

  const match = str.match(/\(([^)]+)\)$/)
  const suffix = match ? match[0] : ''
  const coreLength = maxLength - suffix.length - 4
  if (coreLength > 0) {
    let truncStr = str.slice(0, coreLength) + '...'
    if (suffix) truncStr += ' ' + suffix
    return truncStr

  }

  return str.slice(0, maxLength - 3) + '...'
}

let toDate = (val) => {
  if (!val) return new Date(0)

  if (/^\d{2}\/\d{2}\/\d{4}$/.test(val)) {
    const [d, m, y] = val.split('/').map(Number)
    return new Date(y, m - 1, d)
  }

  return new Date(val)
}

export { truncate, truncateWithSuffix, toDate }